import { LeadByIndicator } from '../../../../components/LeadByIndicator'
import { FieldWithLabel } from '../../../../components/FieldWithLabel/FieldWithLabel'
import { IContractDetails } from '../../types'
import { CONTRACT_CREATION_TYPE } from '../../constants'
import { routes } from 'router/Config/config.routes'
import { Link } from 'components/Link'
import { useSelector } from 'react-redux'
import { getUser } from 'redux/store/user/getters'
import { useMemo } from 'react'

export const LedByInfo = ({ details }: { details: IContractDetails }) => {
  const user = useSelector(getUser)

  const ledByLink = useMemo(() => {
    if (details.creation_type === CONTRACT_CREATION_TYPE.COMMUNITY) {
      return `${routes.myCommunity}${routes.myOrganization}`
    } else if (details.creation_type === CONTRACT_CREATION_TYPE.HEALTH_SYSTEM) {
      return `${routes.myCommunity}${routes.myOrganization}${routes.healthSystems}/${details?.health_systems?.[0]?.uuid}`
    }
    return ''
  }, [details.creation_type, details?.health_systems])
  return (
    <>
      <FieldWithLabel title="Led by" className="add-contract-category__label">
        {user.community &&
        details.creation_type !== CONTRACT_CREATION_TYPE.GPO ? (
          <Link
            to={user.community ? ledByLink : ''}
            className="row align-center gap-4"
          >
            <LeadByIndicator value={details.led_by} />
            {details.creation_type === CONTRACT_CREATION_TYPE.OM_LIFELINE
              ? 'OM Lifeline'
              : details.contract_category_organization_name}
          </Link>
        ) : (
          <div className="row align-center gap-4">
            <LeadByIndicator value={details.led_by} />
            {details.creation_type === CONTRACT_CREATION_TYPE.OM_LIFELINE
              ? 'OM Lifeline'
              : details.contract_category_organization_name}
          </div>
        )}
      </FieldWithLabel>
      {details.creation_type === CONTRACT_CREATION_TYPE.GPO &&
        !!details?.health_systems?.length && (
          <FieldWithLabel
            title="Health system"
            className="add-contract-category__label"
          >
            {user.community ? (
              <Link
                to={
                  user.community
                    ? `${routes.myCommunity}${routes.myOrganization}${routes.healthSystems}/${details?.health_systems[0]?.uuid}`
                    : ''
                }
                className="row align-center gap-4"
              >
                {details?.health_systems[0]?.name}
              </Link>
            ) : (
              <div className="mt-8">{details?.health_systems[0]?.name}</div>
            )}
          </FieldWithLabel>
        )}
    </>
  )
}
